import { getNestedProperty } from '@opallabs/lambda'
import { PhaseItemCollection, State, StateKeys } from '../../../../types'

type GetPhaseItems = (state: State) => PhaseItemCollection | undefined

export const getPhaseItems: GetPhaseItems = (state) =>
  getNestedProperty<PhaseItemCollection>(
    state,
    StateKeys.jsonApiEntities,
    StateKeys.phase_item
  )
